import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import StatCardGroup from "../Common/StatCardGroup";
import OverviewBarChart from "./OverviewBarChart";
import WeatherCard from "./WeatherCard";
import StoreStatus from "./StoreStatus";
import OverviewAlerts from "./Alerts";
import RecentActivity from "./RecentActivity";
import ThroughputHeatmap from "./ThroughputHeatmap";

const Overview = ({ activeFilterType = "" }) => {
  const statsData = useSelector((state) => state.Dashboard?.data?.stats?.stats);


  // Guard: API not loaded yet
  const DASHBOARD_STATS = useMemo(() => {
    return [
      {
        id: "tunnelStatus",
        title: "Tunnel Status",
        value: {
          active: statsData?.tunnelStatus?.active ?? 0,
          inactive: statsData?.tunnelStatus?.inactive ?? 0,
        },
        icon: "tunnelStatus",
        type: "status",
      },
      {
        id: "totalVehicle",
        title: "Total Vehicles in Queue",
        value: statsData?.totalVehicleInQueue ?? 0,
        icon: "totalVehicle",
      },
      {
        id: "queueWaitTime",
        title: "Current Queue Wait Time",
        value: statsData?.avgQueueWaitTime?.time
          ? `${statsData.avgQueueWaitTime.time} ${statsData.avgQueueWaitTime.unit}`
          : "0 mins",
        icon: "queueWaitTime",
      },
      {
        id: "activeWashes",
        title: "Current Active Washes",
        value: statsData?.totalActiveWashes ?? 0,
        icon: "activeWashes",
      },
      {
        id: "vehiclesWashed",
        title: "Total Vehicles Washed",
        value: statsData?.totalWashed ?? 0,
        icon: "vehiclesWashed",
      },
      {
        id: "totalRevenue",
        title: "Total Revenue",
        value: statsData?.totalRevenue ?? 0,
        icon: "totalRevenue",
        type: "price",
      },
      {
        id: "avgWashTime",
        title: "Avg. Exterior Wash Time",
        value: statsData?.avgExteriorWashTime?.time
          ? `${statsData.avgExteriorWashTime.time} ${statsData.avgExteriorWashTime.unit}`
          : "0 mins",
        icon: "avgWashTime",
      },
      {
        id: "appAdoption",
        title: "App Adoption Rate",
        value:
          statsData?.appAdoptionRate != null
            ? `${statsData.appAdoptionRate}`
            : "0%",
        icon: "appAdoption",
      },
    ];
  }, [statsData]);

  return (
    <section className="overview_dashboard">
      <StatCardGroup items={DASHBOARD_STATS} />

      <Row>
        <Col xxl={8} xl={7}>
          <OverviewBarChart activeFilterType={activeFilterType} />
        </Col>
        <Col xxl={4} xl={5}>
          <WeatherCard />
          <StoreStatus />
        </Col>
      </Row>

      <Row>
        <Col xxl={8} xl={7}>
          <ThroughputHeatmap />
        </Col>
        <Col xxl={4} xl={5}>
          <OverviewAlerts />
        </Col>
      </Row>

      {/* <Row>
        <Col lg={12}>
          <RecentActivity />
        </Col>
      </Row> */}
    </section>
  );
};

export default Overview;
